import { normalizeReactionEmojiForDb } from "@/lib/chat/message-reaction";

export type ChatEmojiEntry = {
  emoji: string;
  keywords: string[];
};

export const CHAT_EMOJI_CATALOG: ChatEmojiEntry[] = [
  { emoji: "😀", keywords: ["grinning", "smile", "happy", "face"] },
  { emoji: "😃", keywords: ["smiley", "happy", "face"] },
  { emoji: "😄", keywords: ["smile", "happy", "joy"] },
  { emoji: "😁", keywords: ["beaming", "grin", "happy"] },
  { emoji: "😆", keywords: ["laugh", "squint", "happy"] },
  { emoji: "😅", keywords: ["sweat", "smile", "relief"] },
  { emoji: "🤣", keywords: ["rofl", "laugh", "floor"] },
  { emoji: "😂", keywords: ["joy", "laugh", "tears", "lol"] },
  { emoji: "🙂", keywords: ["slight", "smile"] },
  { emoji: "🙃", keywords: ["upside", "down", "silly"] },
  { emoji: "😉", keywords: ["wink", "flirt"] },
  { emoji: "😊", keywords: ["blush", "smile", "happy"] },
  { emoji: "😇", keywords: ["innocent", "angel", "halo"] },
  { emoji: "🥰", keywords: ["love", "hearts", "smile"] },
  { emoji: "😍", keywords: ["heart", "eyes", "love"] },
  { emoji: "🤩", keywords: ["star", "struck", "excited"] },
  { emoji: "😘", keywords: ["kiss", "love"] },
  { emoji: "😗", keywords: ["kissing", "face"] },
  { emoji: "😚", keywords: ["kiss", "closed", "eyes"] },
  { emoji: "😙", keywords: ["kiss", "smile"] },
  { emoji: "🥲", keywords: ["smile", "tear", "grateful"] },
  { emoji: "😋", keywords: ["yum", "delicious", "tongue"] },
  { emoji: "😛", keywords: ["tongue", "silly"] },
  { emoji: "😜", keywords: ["wink", "tongue", "crazy"] },
  { emoji: "🤪", keywords: ["zany", "crazy", "wild"] },
  { emoji: "😝", keywords: ["tongue", "squint"] },
  { emoji: "🤑", keywords: ["money", "rich", "mouth"] },
  { emoji: "🤗", keywords: ["hug", "hugging"] },
  { emoji: "🤭", keywords: ["hand", "mouth", "oops"] },
  { emoji: "🤫", keywords: ["shh", "quiet", "secret"] },
  { emoji: "🤔", keywords: ["think", "thinking", "hmm"] },
  { emoji: "🤐", keywords: ["zipper", "mouth", "quiet"] },
  { emoji: "🤨", keywords: ["raised", "eyebrow", "skeptical"] },
  { emoji: "😐", keywords: ["neutral", "face", "meh"] },
  { emoji: "😑", keywords: ["expressionless", "blank"] },
  { emoji: "😶", keywords: ["no", "mouth", "silent"] },
  { emoji: "😏", keywords: ["smirk", "sly"] },
  { emoji: "😒", keywords: ["unamused", "annoyed"] },
  { emoji: "🙄", keywords: ["roll", "eyes", "whatever"] },
  { emoji: "😬", keywords: ["grimace", "awkward"] },
  { emoji: "😮‍💨", keywords: ["exhale", "sigh", "relief"] },
  { emoji: "🤥", keywords: ["lying", "pinocchio", "nose"] },
  { emoji: "😌", keywords: ["relieved", "calm"] },
  { emoji: "😔", keywords: ["pensive", "sad", "thoughtful"] },
  { emoji: "😪", keywords: ["sleepy", "tired"] },
  { emoji: "🤤", keywords: ["drool", "drooling"] },
  { emoji: "😴", keywords: ["sleep", "sleeping", "zzz"] },
  { emoji: "😷", keywords: ["mask", "sick", "medical"] },
  { emoji: "🤒", keywords: ["sick", "thermometer", "ill"] },
  { emoji: "🤕", keywords: ["hurt", "bandage", "injured"] },
  { emoji: "🤢", keywords: ["nauseated", "sick", "green"] },
  { emoji: "🤮", keywords: ["vomit", "sick", "puke"] },
  { emoji: "🤧", keywords: ["sneeze", "sick", "tissue"] },
  { emoji: "🥵", keywords: ["hot", "sweating", "heat"] },
  { emoji: "🥶", keywords: ["cold", "freezing", "ice"] },
  { emoji: "🥴", keywords: ["woozy", "dizzy", "drunk"] },
  { emoji: "😵", keywords: ["dizzy", "knocked", "out"] },
  { emoji: "🤯", keywords: ["exploding", "head", "mind", "blown"] },
  { emoji: "🤠", keywords: ["cowboy", "hat"] },
  { emoji: "🥳", keywords: ["party", "celebrate", "birthday"] },
  { emoji: "🥸", keywords: ["disguise", "glasses", "nose"] },
  { emoji: "😎", keywords: ["cool", "sunglasses"] },
  { emoji: "🤓", keywords: ["nerd", "glasses", "geek"] },
  { emoji: "🧐", keywords: ["monocle", "inspect"] },
  { emoji: "😕", keywords: ["confused", "puzzled"] },
  { emoji: "😟", keywords: ["worried", "concerned"] },
  { emoji: "🙁", keywords: ["slight", "frown", "sad"] },
  { emoji: "☹️", keywords: ["frown", "sad"] },
  { emoji: "😮", keywords: ["open", "mouth", "surprised", "wow"] },
  { emoji: "😯", keywords: ["hushed", "surprised"] },
  { emoji: "😲", keywords: ["astonished", "shocked"] },
  { emoji: "😳", keywords: ["flushed", "embarrassed", "blush"] },
  { emoji: "🥺", keywords: ["pleading", "puppy", "eyes", "please"] },
  { emoji: "😦", keywords: ["frown", "open", "mouth"] },
  { emoji: "😧", keywords: ["anguished", "shocked"] },
  { emoji: "😨", keywords: ["fearful", "scared", "afraid"] },
  { emoji: "😰", keywords: ["anxious", "sweat", "nervous"] },
  { emoji: "😥", keywords: ["sad", "relieved", "sweat"] },
  { emoji: "😢", keywords: ["cry", "tear", "sad"] },
  { emoji: "😭", keywords: ["sob", "cry", "tears", "loud"] },
  { emoji: "😱", keywords: ["scream", "fear", "shocked"] },
  { emoji: "😖", keywords: ["confounded", "frustrated"] },
  { emoji: "😣", keywords: ["persevere", "struggle"] },
  { emoji: "😞", keywords: ["disappointed", "sad"] },
  { emoji: "😓", keywords: ["downcast", "sweat"] },
  { emoji: "😩", keywords: ["weary", "tired", "fed", "up"] },
  { emoji: "😫", keywords: ["tired", "exhausted"] },
  { emoji: "🥱", keywords: ["yawn", "tired", "bored"] },
  { emoji: "😤", keywords: ["triumph", "steam", "angry"] },
  { emoji: "😡", keywords: ["angry", "mad", "rage", "pouting"] },
  { emoji: "😠", keywords: ["angry", "mad"] },
  { emoji: "🤬", keywords: ["swearing", "cursing", "symbols"] },
  { emoji: "😈", keywords: ["smiling", "devil", "imp"] },
  { emoji: "👿", keywords: ["angry", "devil", "imp"] },
  { emoji: "💀", keywords: ["skull", "dead", "death"] },
  { emoji: "☠️", keywords: ["skull", "crossbones", "poison"] },
  { emoji: "💩", keywords: ["poop", "poo", "shit"] },
  { emoji: "🤡", keywords: ["clown", "circus"] },
  { emoji: "👹", keywords: ["ogre", "monster", "japanese"] },
  { emoji: "👺", keywords: ["goblin", "monster", "japanese"] },
  { emoji: "👻", keywords: ["ghost", "boo", "halloween"] },
  { emoji: "👽", keywords: ["alien", "ufo", "space"] },
  { emoji: "👾", keywords: ["alien", "monster", "game", "space", "invader"] },
  { emoji: "🤖", keywords: ["robot", "bot"] },
  { emoji: "😺", keywords: ["cat", "grinning", "happy"] },
  { emoji: "😸", keywords: ["cat", "smile", "happy"] },
  { emoji: "😹", keywords: ["cat", "joy", "laugh"] },
  { emoji: "😻", keywords: ["cat", "heart", "eyes", "love"] },
  { emoji: "😼", keywords: ["cat", "smirk", "wry"] },
  { emoji: "😽", keywords: ["cat", "kiss", "kissing"] },
  { emoji: "🙀", keywords: ["cat", "weary", "scream"] },
  { emoji: "😿", keywords: ["cat", "cry", "tear", "sad"] },
  { emoji: "😾", keywords: ["cat", "pouting", "angry"] },
  { emoji: "🙈", keywords: ["see", "no", "evil", "monkey"] },
  { emoji: "🙉", keywords: ["hear", "no", "evil", "monkey"] },
  { emoji: "🙊", keywords: ["speak", "no", "evil", "monkey"] },
  { emoji: "💋", keywords: ["kiss", "mark", "lips"] },
  { emoji: "💌", keywords: ["love", "letter", "envelope"] },
  { emoji: "💘", keywords: ["heart", "arrow", "cupid", "love"] },
  { emoji: "💝", keywords: ["heart", "ribbon", "gift", "love"] },
  { emoji: "💖", keywords: ["sparkling", "heart", "love"] },
  { emoji: "💗", keywords: ["growing", "heart", "love"] },
  { emoji: "💓", keywords: ["beating", "heart", "love"] },
  { emoji: "💞", keywords: ["revolving", "hearts", "love"] },
  { emoji: "💕", keywords: ["two", "hearts", "love"] },
  { emoji: "💟", keywords: ["heart", "decoration", "love"] },
  { emoji: "❣️", keywords: ["heart", "exclamation", "love"] },
  { emoji: "💔", keywords: ["broken", "heart", "sad"] },
  { emoji: "❤️", keywords: ["red", "heart", "love"] },
  { emoji: "🧡", keywords: ["orange", "heart", "love"] },
  { emoji: "💛", keywords: ["yellow", "heart", "love"] },
  { emoji: "💚", keywords: ["green", "heart", "love"] },
  { emoji: "💙", keywords: ["blue", "heart", "love"] },
  { emoji: "💜", keywords: ["purple", "heart", "love"] },
  { emoji: "🤎", keywords: ["brown", "heart", "love"] },
  { emoji: "🖤", keywords: ["black", "heart", "love"] },
  { emoji: "🤍", keywords: ["white", "heart", "love"] },
  { emoji: "💯", keywords: ["hundred", "points", "perfect", "100"] },
  { emoji: "💢", keywords: ["anger", "symbol", "mad"] },
  { emoji: "💥", keywords: ["collision", "boom", "bang"] },
  { emoji: "💫", keywords: ["dizzy", "star", "sparkle"] },
  { emoji: "💦", keywords: ["sweat", "droplets", "water"] },
  { emoji: "💨", keywords: ["dash", "wind", "fast", "running"] },
  { emoji: "🕳️", keywords: ["hole", "empty"] },
  { emoji: "💣", keywords: ["bomb", "explosion"] },
  { emoji: "💬", keywords: ["speech", "bubble", "chat", "talk"] },
  { emoji: "👁️‍🗨️", keywords: ["eye", "speech", "bubble"] },
  { emoji: "🗨️", keywords: ["left", "speech", "bubble"] },
  { emoji: "🗯️", keywords: ["right", "anger", "bubble"] },
  { emoji: "💭", keywords: ["thought", "bubble", "think"] },
  { emoji: "💤", keywords: ["zzz", "sleep", "snore"] },
  { emoji: "👋", keywords: ["wave", "hand", "hello", "hi", "bye"] },
  { emoji: "🤚", keywords: ["raised", "back", "hand", "stop"] },
  { emoji: "🖐️", keywords: ["hand", "fingers", "splayed", "five"] },
  { emoji: "✋", keywords: ["raised", "hand", "stop", "high", "five"] },
  { emoji: "🖖", keywords: ["vulcan", "salute", "spock", "star", "trek"] },
  { emoji: "👌", keywords: ["ok", "hand", "perfect", "good"] },
  { emoji: "🤌", keywords: ["pinched", "fingers", "italian"] },
  { emoji: "🤏", keywords: ["pinching", "hand", "small", "tiny"] },
  { emoji: "✌️", keywords: ["victory", "peace", "two", "fingers"] },
  { emoji: "🤞", keywords: ["crossed", "fingers", "luck", "hope"] },
  { emoji: "🤟", keywords: ["love", "you", "gesture", "ily"] },
  { emoji: "🤘", keywords: ["rock", "on", "horns", "metal"] },
  { emoji: "🤙", keywords: ["call", "me", "hand", "shaka"] },
  { emoji: "👈", keywords: ["point", "left", "finger"] },
  { emoji: "👉", keywords: ["point", "right", "finger"] },
  { emoji: "👆", keywords: ["point", "up", "finger"] },
  { emoji: "🖕", keywords: ["middle", "finger", "rude"] },
  { emoji: "👇", keywords: ["point", "down", "finger"] },
  { emoji: "☝️", keywords: ["index", "pointing", "up"] },
  { emoji: "👍", keywords: ["thumbs", "up", "like", "yes", "good"] },
  { emoji: "👎", keywords: ["thumbs", "down", "dislike", "no", "bad"] },
  { emoji: "✊", keywords: ["raised", "fist", "power"] },
  { emoji: "👊", keywords: ["fist", "bump", "punch"] },
  { emoji: "🤛", keywords: ["left", "fist", "bump"] },
  { emoji: "🤜", keywords: ["right", "fist", "bump"] },
  { emoji: "👏", keywords: ["clap", "applause", "bravo"] },
  { emoji: "🙌", keywords: ["raising", "hands", "celebrate", "hooray"] },
  { emoji: "👐", keywords: ["open", "hands"] },
  { emoji: "🤲", keywords: ["palms", "together", "pray"] },
  { emoji: "🤝", keywords: ["handshake", "deal", "agreement"] },
  { emoji: "🙏", keywords: ["pray", "thanks", "please", "folded", "hands"] },
  { emoji: "✍️", keywords: ["writing", "hand", "write"] },
  { emoji: "💅", keywords: ["nail", "polish", "manicure"] },
  { emoji: "🤳", keywords: ["selfie", "phone", "camera"] },
  { emoji: "💪", keywords: ["muscle", "strong", "flex", "bicep"] },
  { emoji: "🦾", keywords: ["mechanical", "arm", "prosthetic"] },
  { emoji: "🦿", keywords: ["mechanical", "leg", "prosthetic"] },
  { emoji: "🦵", keywords: ["leg", "kick"] },
  { emoji: "🦶", keywords: ["foot", "kick", "stomp"] },
  { emoji: "👂", keywords: ["ear", "hear", "listen"] },
  { emoji: "🦻", keywords: ["ear", "hearing", "aid"] },
  { emoji: "👃", keywords: ["nose", "smell"] },
  { emoji: "🧠", keywords: ["brain", "smart", "think"] },
  { emoji: "🫀", keywords: ["anatomical", "heart", "organ"] },
  { emoji: "🫁", keywords: ["lungs", "breathe", "organ"] },
  { emoji: "🦷", keywords: ["tooth", "dental"] },
  { emoji: "🦴", keywords: ["bone", "skeleton"] },
  { emoji: "👀", keywords: ["eyes", "look", "see", "watch"] },
  { emoji: "👁️", keywords: ["eye", "see", "look"] },
  { emoji: "👅", keywords: ["tongue", "taste", "lick"] },
  { emoji: "👄", keywords: ["mouth", "lips", "kiss"] },
  { emoji: "🎉", keywords: ["party", "popper", "celebrate", "tada"] },
  { emoji: "🎊", keywords: ["confetti", "ball", "celebrate"] },
  { emoji: "🎈", keywords: ["balloon", "party", "birthday"] },
  { emoji: "🎁", keywords: ["gift", "present", "wrapped", "birthday"] },
  { emoji: "🏆", keywords: ["trophy", "win", "champion", "first"] },
  { emoji: "🥇", keywords: ["gold", "medal", "first", "win"] },
  { emoji: "🥈", keywords: ["silver", "medal", "second"] },
  { emoji: "🥉", keywords: ["bronze", "medal", "third"] },
  { emoji: "⚽", keywords: ["soccer", "ball", "football"] },
  { emoji: "🏀", keywords: ["basketball", "ball", "sport"] },
  { emoji: "🏈", keywords: ["football", "american", "sport"] },
  { emoji: "⚾", keywords: ["baseball", "ball", "sport"] },
  { emoji: "🎾", keywords: ["tennis", "ball", "sport"] },
  { emoji: "🏐", keywords: ["volleyball", "ball", "sport"] },
  { emoji: "🎱", keywords: ["pool", "8", "ball", "billiards"] },
  { emoji: "🔥", keywords: ["fire", "flame", "hot", "lit"] },
  { emoji: "✨", keywords: ["sparkles", "shine", "magic", "stars"] },
  { emoji: "🌟", keywords: ["star", "glowing", "shine"] },
  { emoji: "⭐", keywords: ["star", "favorite"] },
  { emoji: "💡", keywords: ["light", "bulb", "idea", "bright"] },
  { emoji: "🌈", keywords: ["rainbow", "pride", "colors"] },
  { emoji: "☀️", keywords: ["sun", "sunny", "weather", "bright"] },
  { emoji: "🌙", keywords: ["moon", "crescent", "night"] },
  { emoji: "⚡", keywords: ["lightning", "bolt", "electric", "fast"] },
  { emoji: "❄️", keywords: ["snowflake", "cold", "winter", "snow"] },
  { emoji: "☁️", keywords: ["cloud", "weather", "sky"] },
  { emoji: "🌧️", keywords: ["rain", "cloud", "weather"] },
  { emoji: "⛄", keywords: ["snowman", "winter", "cold"] },
  { emoji: "🌊", keywords: ["wave", "ocean", "water", "sea"] },
  { emoji: "🍎", keywords: ["apple", "red", "fruit", "food"] },
  { emoji: "🍊", keywords: ["orange", "tangerine", "fruit", "food"] },
  { emoji: "🍋", keywords: ["lemon", "citrus", "fruit", "food"] },
  { emoji: "🍌", keywords: ["banana", "fruit", "food"] },
  { emoji: "🍉", keywords: ["watermelon", "fruit", "food"] },
  { emoji: "🍇", keywords: ["grapes", "fruit", "food"] },
  { emoji: "🍓", keywords: ["strawberry", "fruit", "food", "berry"] },
  { emoji: "🫐", keywords: ["blueberries", "fruit", "food", "berry"] },
  { emoji: "🍒", keywords: ["cherries", "fruit", "food"] },
  { emoji: "🍑", keywords: ["peach", "fruit", "food"] },
  { emoji: "🥭", keywords: ["mango", "fruit", "food", "tropical"] },
  { emoji: "🍍", keywords: ["pineapple", "fruit", "food", "tropical"] },
  { emoji: "🥥", keywords: ["coconut", "fruit", "food", "tropical"] },
  { emoji: "🥑", keywords: ["avocado", "fruit", "food"] },
  { emoji: "🍆", keywords: ["eggplant", "vegetable", "food"] },
  { emoji: "🥦", keywords: ["broccoli", "vegetable", "food", "green"] },
  { emoji: "🌽", keywords: ["corn", "vegetable", "food"] },
  { emoji: "🌶️", keywords: ["pepper", "hot", "spicy", "chili"] },
  { emoji: "🫑", keywords: ["bell", "pepper", "vegetable", "food"] },
  { emoji: "🥕", keywords: ["carrot", "vegetable", "food"] },
  { emoji: "🍔", keywords: ["burger", "hamburger", "food", "fast"] },
  { emoji: "🍟", keywords: ["fries", "french", "food", "fast"] },
  { emoji: "🍕", keywords: ["pizza", "food", "slice"] },
  { emoji: "🌭", keywords: ["hot", "dog", "food"] },
  { emoji: "🥪", keywords: ["sandwich", "food"] },
  { emoji: "🌮", keywords: ["taco", "mexican", "food"] },
  { emoji: "🌯", keywords: ["burrito", "mexican", "food"] },
  { emoji: "🥗", keywords: ["salad", "green", "food", "healthy"] },
  { emoji: "🍝", keywords: ["spaghetti", "pasta", "italian", "food"] },
  { emoji: "🍜", keywords: ["ramen", "noodles", "food", "bowl"] },
  { emoji: "🍣", keywords: ["sushi", "japanese", "food"] },
  { emoji: "🍱", keywords: ["bento", "box", "japanese", "food"] },
  { emoji: "🍰", keywords: ["cake", "shortcake", "dessert", "birthday"] },
  { emoji: "🎂", keywords: ["birthday", "cake", "dessert", "party"] },
  { emoji: "🍩", keywords: ["donut", "doughnut", "dessert", "sweet"] },
  { emoji: "🍪", keywords: ["cookie", "dessert", "sweet"] },
  { emoji: "🍫", keywords: ["chocolate", "bar", "sweet", "candy"] },
  { emoji: "🍬", keywords: ["candy", "sweet"] },
  { emoji: "🍭", keywords: ["lollipop", "candy", "sweet"] },
  { emoji: "☕", keywords: ["coffee", "hot", "drink", "cafe"] },
  { emoji: "🍵", keywords: ["tea", "green", "drink", "cup"] },
  { emoji: "🧃", keywords: ["juice", "box", "drink"] },
  { emoji: "🥤", keywords: ["cup", "straw", "drink", "soda"] },
  { emoji: "🍺", keywords: ["beer", "mug", "drink", "alcohol"] },
  { emoji: "🍻", keywords: ["beers", "cheers", "drink", "alcohol"] },
  { emoji: "🥂", keywords: ["champagne", "clink", "celebrate", "drink"] },
  { emoji: "🍷", keywords: ["wine", "glass", "drink", "alcohol"] },
  { emoji: "🍸", keywords: ["cocktail", "martini", "drink", "alcohol"] },
  { emoji: "🍹", keywords: ["tropical", "drink", "cocktail"] },
  { emoji: "🐶", keywords: ["dog", "puppy", "pet", "animal"] },
  { emoji: "🐱", keywords: ["cat", "kitten", "pet", "animal"] },
  { emoji: "🐭", keywords: ["mouse", "animal", "rodent"] },
  { emoji: "🐹", keywords: ["hamster", "pet", "animal"] },
  { emoji: "🐰", keywords: ["rabbit", "bunny", "animal"] },
  { emoji: "🦊", keywords: ["fox", "animal"] },
  { emoji: "🐻", keywords: ["bear", "animal"] },
  { emoji: "🐼", keywords: ["panda", "bear", "animal"] },
  { emoji: "🐨", keywords: ["koala", "animal"] },
  { emoji: "🐯", keywords: ["tiger", "face", "animal"] },
  { emoji: "🦁", keywords: ["lion", "animal", "king"] },
  { emoji: "🐮", keywords: ["cow", "animal"] },
  { emoji: "🐷", keywords: ["pig", "animal"] },
  { emoji: "🐸", keywords: ["frog", "animal"] },
  { emoji: "🐵", keywords: ["monkey", "face", "animal"] },
  { emoji: "🐔", keywords: ["chicken", "bird", "animal"] },
  { emoji: "🐧", keywords: ["penguin", "bird", "animal", "cold"] },
  { emoji: "🐦", keywords: ["bird", "animal"] },
  { emoji: "🐤", keywords: ["chick", "baby", "bird", "animal"] },
  { emoji: "🦄", keywords: ["unicorn", "fantasy", "magic"] },
  { emoji: "🐝", keywords: ["bee", "honey", "insect", "animal"] },
  { emoji: "🦋", keywords: ["butterfly", "insect", "animal"] },
  { emoji: "🐌", keywords: ["snail", "slow", "animal"] },
  { emoji: "🐙", keywords: ["octopus", "sea", "animal"] },
  { emoji: "🦑", keywords: ["squid", "sea", "animal"] },
  { emoji: "🦀", keywords: ["crab", "sea", "animal"] },
  { emoji: "🐠", keywords: ["fish", "tropical", "sea", "animal"] },
  { emoji: "🐬", keywords: ["dolphin", "sea", "animal"] },
  { emoji: "🐳", keywords: ["whale", "sea", "animal"] },
  { emoji: "🦈", keywords: ["shark", "sea", "animal"] },
  { emoji: "🌸", keywords: ["cherry", "blossom", "flower", "spring"] },
  { emoji: "🌺", keywords: ["hibiscus", "flower", "tropical"] },
  { emoji: "🌻", keywords: ["sunflower", "flower", "yellow"] },
  { emoji: "🌹", keywords: ["rose", "flower", "love", "red"] },
  { emoji: "🌷", keywords: ["tulip", "flower", "spring"] },
  { emoji: "🌱", keywords: ["seedling", "plant", "grow", "green"] },
  { emoji: "🌲", keywords: ["evergreen", "tree", "forest"] },
  { emoji: "🌴", keywords: ["palm", "tree", "tropical", "beach"] },
  { emoji: "🍀", keywords: ["clover", "four", "leaf", "luck"] },
  { emoji: "🍁", keywords: ["maple", "leaf", "fall", "autumn"] },
  { emoji: "🌍", keywords: ["earth", "globe", "europe", "africa", "world"] },
  { emoji: "🌎", keywords: ["earth", "globe", "americas", "world"] },
  { emoji: "🌏", keywords: ["earth", "globe", "asia", "australia", "world"] },
  { emoji: "🚗", keywords: ["car", "automobile", "red", "drive"] },
  { emoji: "🚕", keywords: ["taxi", "cab", "car"] },
  { emoji: "🚌", keywords: ["bus", "transport"] },
  { emoji: "🚎", keywords: ["trolleybus", "transport"] },
  { emoji: "🏎️", keywords: ["racing", "car", "fast", "sport"] },
  { emoji: "🚓", keywords: ["police", "car"] },
  { emoji: "🚑", keywords: ["ambulance", "emergency", "medical"] },
  { emoji: "🚒", keywords: ["fire", "engine", "truck", "emergency"] },
  { emoji: "✈️", keywords: ["airplane", "plane", "fly", "travel"] },
  { emoji: "🚀", keywords: ["rocket", "space", "launch", "fast"] },
  { emoji: "🛸", keywords: ["ufo", "flying", "saucer", "alien"] },
  { emoji: "⛵", keywords: ["sailboat", "boat", "sail", "sea"] },
  { emoji: "🚲", keywords: ["bicycle", "bike", "cycle"] },
  { emoji: "🏠", keywords: ["house", "home", "building"] },
  { emoji: "🏢", keywords: ["office", "building", "work"] },
  { emoji: "🏥", keywords: ["hospital", "medical", "health"] },
  { emoji: "🏫", keywords: ["school", "education", "building"] },
  { emoji: "⛪", keywords: ["church", "religion", "building"] },
  { emoji: "⌚", keywords: ["watch", "time", "clock"] },
  { emoji: "📱", keywords: ["phone", "mobile", "cell", "smartphone"] },
  { emoji: "💻", keywords: ["laptop", "computer", "pc"] },
  { emoji: "⌨️", keywords: ["keyboard", "computer", "type"] },
  { emoji: "🖥️", keywords: ["desktop", "computer", "monitor"] },
  { emoji: "🖨️", keywords: ["printer", "print"] },
  { emoji: "🎮", keywords: ["game", "controller", "video", "play"] },
  { emoji: "🎧", keywords: ["headphones", "music", "listen"] },
  { emoji: "🎤", keywords: ["microphone", "sing", "karaoke"] },
  { emoji: "🎬", keywords: ["clapper", "board", "movie", "film"] },
  { emoji: "🎵", keywords: ["music", "note", "song"] },
  { emoji: "🎶", keywords: ["music", "notes", "song"] },
  { emoji: "📷", keywords: ["camera", "photo", "picture"] },
  { emoji: "📸", keywords: ["camera", "flash", "photo"] },
  { emoji: "🔔", keywords: ["bell", "notification", "ring"] },
  { emoji: "🔕", keywords: ["bell", "slash", "mute", "silent"] },
  { emoji: "📣", keywords: ["megaphone", "announce", "loud"] },
  { emoji: "📢", keywords: ["loudspeaker", "announce"] },
  { emoji: "💰", keywords: ["money", "bag", "cash", "rich"] },
  { emoji: "💵", keywords: ["dollar", "money", "cash", "bill"] },
  { emoji: "💳", keywords: ["credit", "card", "payment", "bank"] },
  { emoji: "🛒", keywords: ["cart", "shopping", "buy", "store"] },
  { emoji: "🎒", keywords: ["backpack", "bag", "school"] },
  { emoji: "👜", keywords: ["handbag", "purse", "bag"] },
  { emoji: "👑", keywords: ["crown", "king", "queen", "royal"] },
  { emoji: "💍", keywords: ["ring", "diamond", "wedding", "engagement"] },
  { emoji: "💎", keywords: ["gem", "diamond", "jewel", "stone"] },
  { emoji: "🔑", keywords: ["key", "lock", "password", "access"] },
  { emoji: "🔒", keywords: ["lock", "locked", "secure", "private"] },
  { emoji: "🔓", keywords: ["unlock", "unlocked", "open"] },
  { emoji: "✅", keywords: ["check", "mark", "done", "yes", "correct"] },
  { emoji: "❌", keywords: ["cross", "mark", "no", "wrong", "cancel"] },
  { emoji: "❓", keywords: ["question", "mark", "what", "help"] },
  { emoji: "❗", keywords: ["exclamation", "mark", "important", "alert"] },
  { emoji: "‼️", keywords: ["double", "exclamation", "mark"] },
  { emoji: "⁉️", keywords: ["exclamation", "question", "mark"] },
  { emoji: "💤", keywords: ["zzz", "sleep", "tired"] },
  { emoji: "🔴", keywords: ["red", "circle", "dot"] },
  { emoji: "🟠", keywords: ["orange", "circle", "dot"] },
  { emoji: "🟡", keywords: ["yellow", "circle", "dot"] },
  { emoji: "🟢", keywords: ["green", "circle", "dot"] },
  { emoji: "🔵", keywords: ["blue", "circle", "dot"] },
  { emoji: "🟣", keywords: ["purple", "circle", "dot"] },
  { emoji: "⚫", keywords: ["black", "circle", "dot"] },
  { emoji: "⚪", keywords: ["white", "circle", "dot"] },
  { emoji: "🟤", keywords: ["brown", "circle", "dot"] },
  { emoji: "⬛", keywords: ["black", "large", "square"] },
  { emoji: "⬜", keywords: ["white", "large", "square"] },
  { emoji: "🔶", keywords: ["orange", "diamond"] },
  { emoji: "🔷", keywords: ["blue", "diamond"] },
  { emoji: "🔺", keywords: ["red", "triangle", "up"] },
  { emoji: "🔻", keywords: ["red", "triangle", "down"] },
  { emoji: "▶️", keywords: ["play", "button", "right", "triangle"] },
  { emoji: "⏸️", keywords: ["pause", "button"] },
  { emoji: "⏹️", keywords: ["stop", "button"] },
  { emoji: "⏺️", keywords: ["record", "button"] },
  { emoji: "⏩", keywords: ["fast", "forward"] },
  { emoji: "⏪", keywords: ["rewind", "fast", "backward"] },
  { emoji: "🔀", keywords: ["shuffle", "random", "tracks"] },
  { emoji: "🔁", keywords: ["repeat", "loop"] },
  { emoji: "🔂", keywords: ["repeat", "one", "loop"] },
  { emoji: "🇫🇷", keywords: ["france", "french", "flag"] },
  { emoji: "🇺🇸", keywords: ["usa", "united", "states", "america", "flag"] },
  { emoji: "🇬🇧", keywords: ["uk", "united", "kingdom", "britain", "flag"] },
  { emoji: "🇩🇪", keywords: ["germany", "german", "flag"] },
  { emoji: "🇪🇸", keywords: ["spain", "spanish", "flag"] },
  { emoji: "🇮🇹", keywords: ["italy", "italian", "flag"] },
  { emoji: "🇯🇵", keywords: ["japan", "japanese", "flag"] },
  { emoji: "🇰🇷", keywords: ["korea", "korean", "flag"] },
  { emoji: "🇨🇳", keywords: ["china", "chinese", "flag"] },
  { emoji: "🇧🇷", keywords: ["brazil", "brazilian", "flag"] },
  { emoji: "🇨🇦", keywords: ["canada", "canadian", "flag"] },
  { emoji: "🇦🇺", keywords: ["australia", "australian", "flag"] },
  { emoji: "🇲🇽", keywords: ["mexico", "mexican", "flag"] },
  { emoji: "🇮🇳", keywords: ["india", "indian", "flag"] },
  { emoji: "🇷🇺", keywords: ["russia", "russian", "flag"] },
  { emoji: "🇵🇱", keywords: ["poland", "polish", "flag"] },
  { emoji: "🇹🇼", keywords: ["taiwan", "flag"] },
];

export function normalizeEmojiSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}

export function isReactionAllowedCatalogEmoji(emoji: string): boolean {
  return normalizeReactionEmojiForDb(emoji) !== null;
}

export const CHAT_REACTION_EMOJI_CATALOG = CHAT_EMOJI_CATALOG.filter((entry) =>
  isReactionAllowedCatalogEmoji(entry.emoji),
);

export function filterChatEmojiCatalog(query: string): ChatEmojiEntry[] {
  const q = normalizeEmojiSearchQuery(query);
  const catalog = CHAT_REACTION_EMOJI_CATALOG;
  if (!q) return catalog;
  return catalog.filter(
    (entry) =>
      entry.emoji.includes(q) ||
      entry.keywords.some((keyword) => keyword.includes(q)),
  );
}
